import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { usersAPI } from '../../services/api';

interface GroupAgentsState {
  agents: any[];
  loading: boolean;
  error: string | null;
  pagination: {
    page: number;
    items_per_page: number;
    total: number;
  };
}

const initialState: GroupAgentsState = {
  agents: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    items_per_page: 10,
    total: 0,
  },
};

export const fetchGroupAgents = createAsyncThunk(
  'groupAgents/fetchGroupAgents',
  async (params: {
    groupId: string;
    page?: number;
    items_per_page?: number;
    sort?: string;
  }) => {
    try {
      const query: any = {
        "where[groupId]": params.groupId,
        page: params.page,
        items_per_page: params.items_per_page,
        sort: params.sort,
      };
      const response = await usersAPI.getUsers(query);
      let agents = [];
      let pagination = {
        page: 1,
        items_per_page: 10,
        total: 0,
      };
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        agents = response.data.data;
        const payload = response.data.payload || {};
        pagination = {
          page: payload.page || 1,
          items_per_page: payload.items_per_page || payload.limit || 10,
          total: payload.total || agents.length,
        };
      } else if (Array.isArray(response.data)) {
        agents = response.data;
        pagination = {
          page: 1,
          items_per_page: response.data.length,
          total: response.data.length,
        };
      } else if (response.data && Array.isArray(response.data.users)) {
        agents = response.data.users;
        pagination.total = agents.length;
      }
      return { items: agents, pagination };
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch group agents.');
    }
  }
);

const groupAgentsSlice = createSlice({
  name: "groupAgents",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload.items;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchGroupAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch group agents';
      });
  },
});

export default groupAgentsSlice.reducer;